import React, { useState, useEffect } from "react";
import { lib } from "../../index";
import { SearchList } from "../../config-center-v3";
import axios from "axios";

export default class extends SearchList {
    getConfig() {
        return axios.get("https://maria.yang800.com/api/data/v2/307").then(e => e.data.data);
    }

    renderContent(row) {
        return <div style={{ whiteSpace: "break-spaces" }}>{row.content}</div>;
    }
}
